/**
 * External dependencies
 */
import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

/**
 * Internal dependencies
 */
import EyeClosed from '@/assets/svg-icons/eye-closed';
import EyeOpened from '@/assets/svg-icons/eye-opened';
import Loader from '@/assets/svg-icons/loader';
import SuccessTick from '@/assets/svg-icons/success-tick';
import PasswordInputRules from './password-input-rules';

export default function PasswordInput({
    name,
    value,
    className = 'form-controller-wrapper',
    autoComplete,
    required,
    isFocused,
    handleChange,
    placeholder,
    errorText,
    showErrorBorder,
    label,
    title,
    id,
    strict = false,
    disabled = false,
    loading = false,
    success = false,
    onBlur = () => {},
}) {
    const input = useRef();
    const [eye, setEye] = useState(false);
    const [showSuccess, setShowSucess] = useState(false);
    const [isStrictValid, setIsStrictValid] = useState(false);

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, []);

    useEffect(() => {
        let successTickAnimation = null;

        if (success) {
            setShowSucess(true);
            successTickAnimation = setTimeout(() => setShowSucess(false), 3000);
        }

        return () => {
            if (success) {
                clearTimeout(successTickAnimation);
            }
        };
    }, [success]);

    const showHideInput = () => {
        setEye(!eye);
    };

    return (
        <div
            className={cx('field field--password', className, {
                'with-title': title,
                'field--valid': isStrictValid,
                'field--error-border': showErrorBorder && errorText,
            })}
        >
            <div className="field__control">
                {title && <span className="field__title">{title}</span>}
                <input
                    type={eye ? 'text' : 'password'}
                    name={name}
                    id={id}
                    value={value}
                    placeholder={label ? label : placeholder}
                    className="field__input"
                    ref={input}
                    autoComplete={autoComplete}
                    required={required}
                    disabled={disabled}
                    onBlur={onBlur}
                    onChange={(e) => handleChange(e)}
                />

                {label && (
                    <label className="field__label" htmlFor={id}>
                        {label}
                    </label>
                )}

                <span onClick={showHideInput} className="field__eye">
                    {loading ? (
                        <Loader width={32} />
                    ) : showSuccess ? (
                        <SuccessTick />
                    ) : eye ? (
                        <EyeOpened />
                    ) : (
                        <EyeClosed />
                    )}
                </span>
            </div>

            {errorText && <p className="field__error">{errorText}</p>}

            {strict && <PasswordInputRules value={value} setIsStrictValid={setIsStrictValid} />}
        </div>
    );
}
